<div class="fdes-thermal">
  <div class="fdes-thermal__head">
    <span class="fdes-thermal__ic"><mat-icon>bolt</mat-icon></span>
    <span class="fdes-thermal__title">{{ title || ('fdes_thermal_title' | translate) }}</span>
    <span class="fdes-thermal__lock"><mat-icon>lock</mat-icon>{{ 'fdes_thermal_locked' | translate }}</span>
  </div>
  <div class="fdes-thermal__inner">
    <div class="fdes-thermal__klabel">{{ 'fdes_thermal_total_consumption' | translate }}</div>
    <div class="fdes-thermal__kval num">
      {{ fmt(conso, 1) }} <span>{{ consoUnit }}</span>
    </div>
    <div class="fdes-thermal__section">{{ 'fdes_thermal_energy_ratios' | translate }}</div>
    <div class="fdes-bar">
      <div class="fdes-bar__row">
        <span>{{ 'fdes_thermal_electricity' | translate }}</span
        ><span class="num">{{ fmt(elec, 1) }} %</span>
      </div>
      <div class="fdes-bar__track"><div class="fdes-bar__fill fdes-bar__fill--elec" [style.width.%]="elec"></div></div>
    </div>
    <div class="fdes-bar">
      <div class="fdes-bar__row">
        <span>{{ 'fdes_thermal_fuels' | translate }}</span
        ><span class="num">{{ fmt(comb, 1) }} %</span>
      </div>
      <div class="fdes-bar__track"><div class="fdes-bar__fill fdes-bar__fill--comb" [style.width.%]="comb"></div></div>
    </div>
    <div class="fdes-bar">
      <div class="fdes-bar__row">
        <span>{{ 'fdes_thermal_gnr' | translate }}</span
        ><span class="num">{{ fmt(gnr, 1) }} %</span>
      </div>
      <div class="fdes-bar__track"><div class="fdes-bar__fill fdes-bar__fill--gnr" [style.width.%]="gnr"></div></div>
    </div>
    <div class="fdes-thermal__note"><mat-icon>lock</mat-icon>{{ 'fdes_thermal_ratios_locked' | translate }}</div>
    <div class="fdes-thermal__sep"></div>
    <div class="fdes-thermal__fuels">
      <div class="fdes-thermal__fuels-head">
        <span>{{ 'fdes_thermal_fuel_used' | translate }}</span>
        <span>FE ({{ feUnit }})</span>
      </div>
      <div class="fdes-thermal__fuel-row" *ngFor="let c of combustibles">
        <span class="fdes-thermal__fuel-name">{{ c.label }}</span>
        <span class="fdes-thermal__fuel-pct num">{{ fmt(c.usagePct ?? 0, 2) }} %</span>
        <span class="num fdes-thermal__fe">{{ c.environmentalFactor != null ? fmt(c.environmentalFactor, 4) : '—' }}</span>
      </div>
    </div>
  </div>
</div>
